import type { PostHog } from "posthog-js";

export type CtaLocation =
  | "header"
  | "hero_badge"
  | "hero_button"
  | "offer_card"
  | "footer";

export function captureCtaClick(
  posthog: PostHog,
  payload: { audience: string; ctaLocation: CtaLocation },
): void {
  posthog.capture("landing_audience_cta_clicked", {
    audience: payload.audience,
    cta_location: payload.ctaLocation,
  });
}
